import { render, staticRenderFns } from "./insert.vue?vue&type=template&id=5d184bf9&scoped=true"
import script from "./insert.vue?vue&type=script&lang=js"
export * from "./insert.vue?vue&type=script&lang=js"
import style0 from "./insert.vue?vue&type=style&index=0&id=5d184bf9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d184bf9",
  null
  
)

export default component.exports